import axios from 'axios'
import Qs from 'qs'
import fileSaver from 'file-saver'
import store from '@/store'
import config from '@/utils/config'

const apiSferest = axios.create({
  baseURL: config.urlApiBack,
  paramsSerializer: array => Qs.stringify(array, {
    arrayFormat: 'repeat'
  }),
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: 60000,
  data: {}
})

export const getArray = (url, params = undefined) => {
  return new Promise((resolve, reject) => {
    apiSferest.get(url, {
      params,
      data: {}
    }).then((res) => {
      if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        reject(new Error('Error de conexión'))
        return
      }
      resolve(res)
    }, (err) => {
      // Ignore 404 error when array is search, empty array is return
      if (err.request.status === 404) {
        store.dispatch('errors/empty')
        resolve({ data: [], headers: {} })
      }
      reject(err)
    })
  })
}

export const get = (url, params = undefined) => {
  return new Promise((resolve, reject) => {
    apiSferest.get(url, {
      params,
      data: {}
    }).then((res) => {
      if (res.data && typeof res.data !== 'object') {
        reject(new Error('Error de conexión'))
        return
      }
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}

export const download = (url, params = undefined) => {
  return new Promise((resolve, reject) => {
    apiSferest.get(url, {
      params,
      data: {},
      headers: {
        'Accept': 'application/json'
      }
    }).then((res) => {
      var binary = atob(res.data.file.replace(/\s/g, ''))
      var len = binary.length
      var buffer = new ArrayBuffer(len)
      var view = new Uint8Array(buffer)
      for (var i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i)
      }
      let blob = new Blob([view], {
        type: params.format
      })
      fileSaver.saveAs(blob, res.data.name)
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}

export const post = (url, body, params = {}) => {
  return new Promise((resolve, reject) => {
    let requestParams = {
      params
    }
    let headers = params.headers
    if (headers) {
      delete requestParams.params.headers
      requestParams.headers = headers
    }
    apiSferest.post(url, body, requestParams).then((res) => {
      if (res.data && typeof res.data !== 'object') {
        reject(new Error('Error de conexión'))
        return
      }
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}

export const put = (url, body, params = {}) => {
  return new Promise((resolve, reject) => {
    apiSferest.put(url, body, {
      params
    }).then((res) => {
      if (res.data && typeof res.data !== 'object') {
        reject(new Error('Error de conexión'))
        return
      }
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}

export const remove = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    apiSferest.delete(url, {
      params,
      data: {}
    }).then((res) => {
      resolve(res)
    })
  })
}

export const removeList = (url, array, params) => {
  return new Promise((resolve, reject) => {
    Promise.all(
      array.map(id => apiSferest.delete(url.replace('{id}', id), { params, data: {} })
        .then((response) => {
          return ({
            id,
            response
          })
        })
        .catch(({
          response
        }) => {
          return ({
            id,
            response
          })
        }))
    ).then((res) => {
      resolve(res)
    })
  })
}

export default apiSferest
